import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonHighlight',
  standalone: false,
})
export class JsonHighlightPipe implements PipeTransform {
  transform(value: any): string {
    let result = '';
    if (typeof value !== 'string') {
      result = JSON.stringify(value, undefined, 2);
    }
    result = result.replace(
      /"([^"]+)":/g,
      '<span class="blue-theme-text-2">"$1":</span>'
    );
    return result;
  }
}
